import { FC, ReactNode } from 'react';
import { HelmetProvider } from 'react-helmet-async';

import { MetaProvider } from './providers';

interface UnauthenticatedProviderProps {
    children: ReactNode;
}

const UnauthenticatedProvider: FC<UnauthenticatedProviderProps> = ({ children }): JSX.Element => {
    return (
        <HelmetProvider>
            <MetaProvider>{children}</MetaProvider>
        </HelmetProvider>
    );
};

export default UnauthenticatedProvider;
